type KeyOptions<T> = {
	getOptionKey?: (option: T) => string;
	isEqual?: (option: T, value: T) => boolean;
};

/** The option's identity: `getOptionKey` when given, else the string itself or the record's `id`. */
export function optionKey<T>(option: T, getOptionKey?: (option: T) => string): string {
	if (getOptionKey) return getOptionKey(option);
	if (typeof option === "string") return option;
	return String((option as { id?: unknown }).id);
}

/** The option's text: `getOptionLabel` when given, else the string itself, the record's `name`, or its key. */
export function optionLabel<T>(option: T, getOptionLabel?: (option: T) => string): string {
	if (getOptionLabel) return getOptionLabel(option);
	if (typeof option === "string") return option;
	const name = (option as { name?: unknown }).name;
	return typeof name === "string" && name !== "" ? name : optionKey(option);
}

/** Whether an option is the value: `isEqual` when given, else equal keys (records re-fetched compare equal). */
export function sameOption<T>(option: T, value: T, opts: KeyOptions<T> = {}): boolean {
	if (opts.isEqual) return opts.isEqual(option, value);
	return optionKey(option, opts.getOptionKey) === optionKey(value, opts.getOptionKey);
}
